import { merge } from 'lodash'
const zhCNJSONFiles = require.context('@/i18n/zhCn/', false)
const enUSJSONFiles = require.context('@/i18n/enUs/', false)

const i18nEnUs = merge(...enUSJSONFiles.keys().map(obj => {
  return enUSJSONFiles(obj)
}, {}))
const i18nZhCn = merge(...zhCNJSONFiles.keys().map(obj => {
  return zhCNJSONFiles(obj)
}, {}))

export const i18nJson = merge(
  { },
  i18nEnUs,
  i18nZhCn,
)

export default i18nJson
